import Awesomplete from '../../../../../../node_modules/awesomplete/awesomplete.min';

const $ = jQuery;

export default class Comboplete {
    constructor() {
        if ($('#pricetable__awesomplete .mobile__list').length <= 0) {
            return;
        }
        if ($('#pricetable__awesomplete .mobile__select').length <= 0) {
            return;
        }

        let list = [];

        $('#pricetable__awesomplete .mobile__list').find('li').each((index, li) => {
            if ($(li).data('value').length > 0) {
                list.push(
                    {
                        label: $(li).text(),
                        value: $(li).data('value')
                    }
                );
            }
        });
        this._initComboplete($('#pricetable__awesomplete .mobile__select'), list);
    }

    _initComboplete($input, list) {
        let awesomplete = new Awesomplete($input[0], {
            autoFirst: true,
            minChars: 0,
            list: list,
            filter: function (text, input) {
                return true;
            },
            replace: function (listItem) {
                let $label = $input.closest('.form-field').find('.form-field__label > span');
                $label.text(listItem.label);
                $input.val(listItem.value);
                $input.change();
                history.pushState(
                    {
                        urlPath: '#' + listItem.value.replace('pricetable-', '')
                    },
                    '',
                    '#' + listItem.value.replace('pricetable-', '')
                );
            }
        });
        $input.on('click', () => {
            if (awesomplete.ul.childNodes.length === 0) {
                awesomplete.minChars = 0;
                awesomplete.evaluate();
            }
            else if (awesomplete.ul.hasAttribute('hidden')) {
                awesomplete.open();
            }
            else {
                awesomplete.close();
            }
        });
    }
}



// WEBPACK FOOTER //
// ./app/themes/template/res/js/src/Comboplete.js